
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo-online",
      function () {
        return require("private-next-pages/emprestimo-online.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emprestimo-online"])
      });
    }
  